import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import "./Row.css";
import YouTube from "react-youtube";
import apiUrl from "../../api/config.json";
import Movie from "./Movie/MovieCard";

const API_KEY = apiUrl.APIKey;

function Row({ title, fetchUrl, isLargeRow }) {
	const [movies, setMovies] = useState([]);
	const [trailerUrl, setTrailerUrl] = useState("");
	const [isMessage, setMessage] = useState("");
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		async function fetchData() {
			const request = await axios.get(fetchUrl);
			setMovies(request.data.results || request.data.cast);
			return request;
		}
		fetchData();
	}, [fetchUrl]);

	const opts = {
		width: "100%",
		playerVars: {
			autoPlay: 1,
		},
	};

	function TrailerVideo(request) {
		if (request.data.results.length > 0) {
			setMessage("");
			const getTrailer = request.data.results.filter((result) => {
				return result.type === "Trailer" ? result.key : null;
			});
			setTrailerUrl(getTrailer[0].key);
			return request;
		} else {
			setMessage("No trailer found");
		}
	}

	const movieFocus = (movie) => {
		if (isActive === movie.id) {
			setIsActive(false);
		} else {
			setTrailerUrl("");
			setMessage("");
			setIsActive(movie.id);
		}
	};

	const handleMovieClick = (movie) => {
		if (trailerUrl) {
			setTrailerUrl("");
			setMessage("");
		} else {
			async function fetchTrailer() {
				try {
					const request = await axios.get(
						`/movie/${movie.id}/videos?api_key=${API_KEY}&language=en-US`
					);
					TrailerVideo(request);
				} catch (err) {
					if (err.response) {
						const request = await axios.get(
							`/tv/${movie.id}/videos?api_key=${API_KEY}&language=en-US`
						);
						TrailerVideo(request);
					} else {
						console.log("No Movie found?");
					}
				}
			}
			fetchTrailer();
		}
	};

	return (
		<div className="row">
			<div className="row__header">
				<h2 className="row__title">{title}</h2>
			</div>
			<div className="row__posters">
				{movies?.map(
					(movie) =>
						((isLargeRow && movie.poster_path) ||
							(!isLargeRow && movie.backdrop_path)) && (
							<Movie
								movie={movie}
								key={movie.id}
								isActive={isActive === movie.id}
								handleMovieClick={handleMovieClick}
								movieFocus={movieFocus}
							/>
						)
				)}
			</div>
			{trailerUrl && (
				<YouTube videoId={trailerUrl} id={trailerUrl} opts={opts} />
			)}
			{isMessage && (
				<div className="noTrailer">
					<h2>{isMessage}</h2>
				</div>
			)}
		</div>
	);
}

export default Row;
